import { styled } from '@withjoy/joykit';

export const DayContainer = styled.div`
  margin-bottom: 2rem;
`;

export const DayTitle = styled.div`
  font-weight: bold;
  margin-bottom: 0.5rem;
`;

export const EventsList = styled.div`
  border-left: 2px solid #ccc;
  margin-left: 1rem;
  padding-left: 1rem;
`;

export const EventItem = styled.div`
  margin-bottom: 1.5rem;
  position: relative;
`;

export const EventDot = styled.div`
  position: absolute;
  left: -23px;
  top: 0;
  width: 12px;
  height: 12px;
  background: #1976d2;
  border-radius: 50%;
`;

export const EventTime = styled.div`
  font-weight: 600;
  font-size: 0.85em;
`;

export const EventTitle = styled.div`
  font-weight: 500;
`;

export const EventDescription = styled.div`
  color: #555;
  font-size: 0.9em;
`;
